export enum SupplierType {
  SUPPLIER_MANAGED = 'supplier_managed',
  SELF_MANAGED = 'self_managed',
}